import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '@crosscutting/public_api';
import { environment } from '@env/environment';
import { Adres, RelatieResponse } from '@models/relatie';
import { FormatHelper } from '@services/public_api';

@Injectable()
export class RelatieService {
  woonadresId = "0002";
  correspondentieadresId = "0001";
  defaultAdresId = "XXDEFAULT";

  constructor(private _http: HttpService) { }

  getRelatie(): Observable<RelatieResponse> {
    return this._http.get<RelatieResponse>(environment.relatieUrl);
  }

  getWoonplaats(adressen: Adres[]): Adres {
    if (adressen?.length > 0) {
      let vandaag = new Date();
      let geldigeAdressen = adressen.filter(a => FormatHelper.formatDateFromString(a.geldigVan, 'yyyy-mm-dd') <= vandaag && FormatHelper.formatDateFromString(a.geldigTot, 'yyyy-mm-dd') >= vandaag)

      if (geldigeAdressen?.length > 0) {
        let huidigAdres = this.filterAdres(geldigeAdressen, this.woonadresId);
        if (huidigAdres != null) {
          return huidigAdres;
        }
        huidigAdres = this.filterAdres(geldigeAdressen, this.defaultAdresId);
        if (huidigAdres != null) {
          return huidigAdres;
        }
        return this.filterAdres(geldigeAdressen, this.correspondentieadresId);
      }
    }
    return null;
  }

  private filterAdres(adressen: Adres[], adressoortCode: string): Adres {
    if (adressen == null) return null;

    let vandaag = new Date();
    let gefilterdeAdressen = adressen.filter(a => a.adresHoedanigheid.find(ah => ah.adressoort?.code === adressoortCode
      && FormatHelper.formatDateFromString(ah.geldigVan, 'yyyy-mm-dd') <= vandaag
      && FormatHelper.formatDateFromString(ah.geldigTot, 'yyyy-mm-dd') >= vandaag));

    if (gefilterdeAdressen == null) return null;

    return gefilterdeAdressen[0];
  }
}
